import { Spinner } from "components/ui/spinner";
import ScheduleComponent from "features/TraxxionSchedule/Component";
import DateFiltersProvider from "components/shared/filters/DateFilters/context";
import { ScheduleProvider } from "features/TraxxionSchedule/Component/context/Schedule";
import { ScrollProvider } from "features/TraxxionSchedule/Component/context/Scroll";
import { MenuProvider } from "features/TraxxionSchedule/Component/context/Menu";
import { useProfile } from "../context";

function Schedule() {
	const { user, isSelf } = useProfile();
	const providerType = isSelf ? "my-profile" : "profile";

	return (
		<div className="tw-border tw-w-full tw-p-4 tw-rounded-xl tw-overflow-hidden tw-h-full tw-flex tw-flex-col">
			{!user ? (
				<div className="tw-flex tw-items-center tw-justify-center tw-flex-1">
					<Spinner className="tw-text-primary tw-size-8" />
				</div>
			) : (
				<div className="tw-flex-1 tw-min-h-0 tw-overflow-hidden">
					<DateFiltersProvider urlParams={false} modes={["day", "week"]} mode="week">
						<ScheduleProvider type={providerType}>
							<ScrollProvider>
								<MenuProvider>
									<ScheduleComponent />
								</MenuProvider>
							</ScrollProvider>
						</ScheduleProvider>
					</DateFiltersProvider>
				</div>
			)}
		</div>
	);
}

export default Schedule;
